module.exports = __webpack_public_path__ + "static/media/background_das.86507ff6.jpg";